import React, { FC, ReactNode } from 'react'
import { Card as VendorCard } from 'react-bootstrap'

import styled from 'styled-components'

const S = {
    Card: styled(VendorCard)`
        .card-body {
            display: flex;
            flex-direction: column;
        }
    `,
}

export interface AssetCardContainerProps {
    children: ReactNode
    title: string
}

const AssetCardContainer: FC<AssetCardContainerProps> = ({
    children,
    title,
}: AssetCardContainerProps) => (
    <S.Card body className="mb-3 h-100">
        <h6 className="mb-3">{title}</h6>
        {children}
    </S.Card>
)

export default AssetCardContainer
